import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const CtaStrip = ({ heading, subheading, primary, secondary, testid = "cta-strip" }) => (
  <section className="relative overflow-hidden bg-[#0b1322]" data-testid={testid}>
    <div className="absolute inset-0 dot-grid-light opacity-[0.12]" />
    <div className="absolute -top-32 left-1/2 h-80 w-[120%] -translate-x-1/2 rounded-full bg-[#b91c1c]/15 blur-3xl" />
    <div className="relative mx-auto max-w-4xl px-6 py-20 text-center sm:py-24">
      <Reveal>
        <h2 className="font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl text-balance">
          {heading}
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg">{subheading}</p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <Link
            to={primary.to}
            data-testid={`${testid}-primary-btn`}
            className="group inline-flex items-center gap-2 rounded-md bg-[#b91c1c] px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-[#991b1b]"
          >
            {primary.label}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          {secondary && (
            <Link
              to={secondary.to}
              data-testid={`${testid}-secondary-btn`}
              className="inline-flex items-center gap-2 rounded-md border border-slate-600 px-7 py-3.5 text-sm font-semibold text-slate-200 transition-colors duration-300 hover:border-slate-400 hover:text-white"
            >
              {secondary.label}
            </Link>
          )}
        </div>
      </Reveal>
    </div>
  </section>
);
